/* @ngInject */

export default (
  $q,
  $rootScope,
  helperService,
  helperPdfService,
  dateTimeService,
  quickToolService,
  assetFinanceService,
  AssetFinanceProposalAmortizationSchedule,
  INSTANCE
) => ({
  createAssetFinanceAmortizationSchedule: ({
    contacts,
    financeProposal,
    ballonSchedule,
    ticket,
    settlementDate,
    isCommercial,
    isQuickTool,
    isView
  }) => {
    const deferred = $q.defer();
    const currentOrganization = $rootScope.CurrentOrganization;
    const currentAccount = $rootScope.CurrentAccount;
    const currentCurrency = $rootScope.CurrentCurrency();
    const currentTimeZone = $rootScope.CurrentTimeZone();
    const terms = helperService.getAvailableTermInMonths({
      isRegular: true
    });
    const clientNames = _.map(contacts, (c) => c.getName()).join(', ');
    const netAmountFinanced = financeProposal?.netAmountFinanced || 0;
    const term = _.find(terms, (t) => t?.value === financeProposal?.term);
    const estimatedBorrowerRate = financeProposal?.estimatedBorrowerRate || 0;
    const balloonValue = financeProposal?.balloonValue || 0;
    const payments = financeProposal?.payments ? 'Advance' : 'Arrears';

    const structureBody = [
      [
        {
          text: 'Net amount financed',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Term',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: `${isCommercial ? 'Interest rate' : 'Customer rate'}`,
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Balloon/Residual value',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Payments',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Payment frequency',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Settlement date',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        }
      ],
      [
        {
          text: netAmountFinanced.formatWithCurrency(currentCurrency, 2),
          bold: true,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: term?.title || '-',
          bold: true,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: `${estimatedBorrowerRate.toFixed(2)}%`,
          bold: true,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: balloonValue.formatWithCurrency(currentCurrency, 2),
          bold: true,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: payments,
          bold: true,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: financeProposal?.paymentFrequency?.title || '-',
          bold: true,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text:
            dateTimeService.getFormattedDate(ticket?.values?.onceOffDueDate || 0) ||
            dateTimeService.getFormattedDate(settlementDate || 0) ||
            '-',
          bold: true,
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        }
      ]
    ];

    const prepareAmortizationScheduleRow = ({ amortizationSchedule, count }) => [
      {
        text: count,
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      },
      {
        text: amortizationSchedule.getPaymentDate(),
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      },
      {
        text: (amortizationSchedule?.beginningBalance || 0).formatWithCurrency(
          currentCurrency,
          2
        ),
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      },
      {
        text: (amortizationSchedule?.repayment || 0).formatWithCurrency(currentCurrency, 2),
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      },
      {
        text: (amortizationSchedule?.principalReduction || 0).formatWithCurrency(
          currentCurrency,
          2
        ),
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      },
      {
        text: (amortizationSchedule?.interestPaid || 0).formatWithCurrency(currentCurrency, 2),
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      },
      {
        text: (amortizationSchedule?.interestDeferred || 0).formatWithCurrency(
          currentCurrency,
          2
        ),
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      },
      {
        text: (amortizationSchedule?.endingBalance || 0).formatWithCurrency(currentCurrency, 2),
        style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
      }
    ];

    const amortizationSchedulesBody = [
      [
        {
          text: '#',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Date',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Contract balance',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Payment',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Principal reduction',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Interest',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Interest deferred',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        },
        {
          text: 'Closing balance',
          bold: true,
          style: [
            'tableFontSize',
            'tableHeader',
            'tableCellLeftAlign',
            'tableCellMarginLeftTopBottom'
          ]
        }
      ]
    ];

    let count = 1;
    let lastIndex = 0;
    const monthOfStartOfFinancialYear =
      helperService.getOrganizationCountry().cca2 === 'NZ' ? 4 : 6;
    const len = financeProposal?.amortizationSchedules?.length;
    for (let i = 0; i < len; i += 1) {
      const amortizationSchedule = AssetFinanceProposalAmortizationSchedule.Build(
        financeProposal?.amortizationSchedules[i]
      );
      if (
        moment(amortizationSchedule.paymentDate, 'X').month() === monthOfStartOfFinancialYear
      ) {
        const totalRepayment = _.reduce(
          financeProposal.amortizationSchedules.slice(lastIndex, i),
          (sum, n) => _.add(sum, helperService.round({ value: n?.repayment || 0 })),
          0
        );
        const totalPrincipalReduction = _.reduce(
          financeProposal.amortizationSchedules.slice(lastIndex, i),
          (sum, n) => _.add(sum, helperService.round({ value: n?.principalReduction || 0 })),
          0
        );
        const totalInterestPaid = _.reduce(
          financeProposal.amortizationSchedules.slice(lastIndex, i),
          (sum, n) => _.add(sum, helperService.round({ value: n?.interestPaid || 0 })),
          0
        );
        amortizationSchedulesBody.push([
          {
            colSpan: 2,
            text: 'End of financial year',
            style: [
              'tableFontSize',
              'tableSubHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          '',
          {
            text: (
              financeProposal?.amortizationSchedules[i - 1]?.beginningBalance || 0
            ).formatWithCurrency(currentCurrency, 2),
            style: [
              'tableFontSize',
              'tableSubHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          {
            text: totalRepayment.formatWithCurrency(currentCurrency, 2),
            style: [
              'tableFontSize',
              'tableSubHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          {
            text: totalPrincipalReduction.formatWithCurrency(currentCurrency, 2),
            style: [
              'tableFontSize',
              'tableSubHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          {
            text: totalInterestPaid.formatWithCurrency(currentCurrency, 2),
            style: [
              'tableFontSize',
              'tableSubHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          {
            text: (
              financeProposal?.amortizationSchedules[i - 1]?.interestDeferred || 0
            ).formatWithCurrency(currentCurrency, 2),
            style: [
              'tableFontSize',
              'tableSubHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          },
          {
            text: (
              financeProposal?.amortizationSchedules[i - 1]?.endingBalance || 0
            ).formatWithCurrency(currentCurrency, 2),
            style: [
              'tableFontSize',
              'tableSubHeader',
              'tableCellLeftAlign',
              'tableCellMarginLeftTopBottom'
            ]
          }
        ]);
        amortizationSchedulesBody.push(
          prepareAmortizationScheduleRow({ amortizationSchedule, count })
        );
        count += 1;
        lastIndex = angular.copy(i);
      } else {
        amortizationSchedulesBody.push(
          prepareAmortizationScheduleRow({ amortizationSchedule, count })
        );
        count += 1;
      }
    }

    if (financeProposal?.balloonValue || !_.isEmpty(ballonSchedule)) {
      amortizationSchedulesBody.push([
        {
          text: '',
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: dateTimeService.getFormattedDate(ballonSchedule?.paymentDate || 0),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: ballonSchedule?.beginningBalance.formatWithCurrency(currentCurrency, 2),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: ballonSchedule?.repayment.formatWithCurrency(currentCurrency, 2),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: ballonSchedule?.principalReduction.formatWithCurrency(currentCurrency, 2),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: ballonSchedule?.interestPaid.formatWithCurrency(currentCurrency, 2),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: ballonSchedule?.interestDeferred.formatWithCurrency(currentCurrency, 2),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        },
        {
          text: ballonSchedule?.endingBalance.formatWithCurrency(currentCurrency, 2),
          style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
        }
      ]);
    }

    const totalLastRepayment = _.add(
      _.reduce(
        financeProposal.amortizationSchedules.slice(
          lastIndex,
          financeProposal?.amortizationSchedules?.length - 1
        ),
        (sum, n) => _.add(sum, helperService.round({ value: n?.repayment || 0 })),
        0
      ),
      ballonSchedule?.repayment || 0
    );
    const totalLastPrincipalReduction = _.add(
      _.reduce(
        financeProposal.amortizationSchedules.slice(
          lastIndex,
          financeProposal?.amortizationSchedules?.length - 1
        ),
        (sum, n) => _.add(sum, helperService.round({ value: n?.principalReduction || 0 })),
        0
      ),
      ballonSchedule?.principalReduction || 0
    );
    const totalLastInterestPaid = _.add(
      _.reduce(
        financeProposal.amortizationSchedules.slice(
          lastIndex,
          financeProposal?.amortizationSchedules?.length - 1
        ),
        (sum, n) => _.add(sum, helperService.round({ value: n?.interestPaid || 0 })),
        0
      ),
      ballonSchedule?.interestPaid || 0
    );
    amortizationSchedulesBody.push([
      {
        colSpan: 2,
        text: 'End of contract',
        style: [
          'tableFontSize',
          'tableSubHeader',
          'tableCellLeftAlign',
          'tableCellMarginLeftTopBottom'
        ]
      },
      '',
      {
        text: (financeProposal?.balloonValue
          ? ballonSchedule?.beginningBalance || 0
          : financeProposal?.amortizationSchedules[
              financeProposal?.amortizationSchedules?.length - 1
            ]?.beginningBalance || 0
        ).formatWithCurrency(currentCurrency, 2),
        style: [
          'tableFontSize',
          'tableSubHeader',
          'tableCellLeftAlign',
          'tableCellMarginLeftTopBottom'
        ]
      },
      {
        text: totalLastRepayment.formatWithCurrency(currentCurrency, 2),
        style: [
          'tableFontSize',
          'tableSubHeader',
          'tableCellLeftAlign',
          'tableCellMarginLeftTopBottom'
        ]
      },
      {
        text: totalLastPrincipalReduction.formatWithCurrency(currentCurrency, 2),
        style: [
          'tableFontSize',
          'tableSubHeader',
          'tableCellLeftAlign',
          'tableCellMarginLeftTopBottom'
        ]
      },
      {
        text: totalLastInterestPaid.formatWithCurrency(currentCurrency, 2),
        style: [
          'tableFontSize',
          'tableSubHeader',
          'tableCellLeftAlign',
          'tableCellMarginLeftTopBottom'
        ]
      },
      {
        text: (financeProposal?.balloonValue
          ? ballonSchedule?.interestDeferred || 0
          : financeProposal?.amortizationSchedules[
              financeProposal?.amortizationSchedules?.length - 1
            ]?.interestDeferred || 0
        ).formatWithCurrency(currentCurrency, 2),
        style: [
          'tableFontSize',
          'tableSubHeader',
          'tableCellLeftAlign',
          'tableCellMarginLeftTopBottom'
        ]
      },
      {
        text: (financeProposal?.balloonValue
          ? ballonSchedule?.endingBalance || 0
          : financeProposal?.amortizationSchedules[
              financeProposal?.amortizationSchedules?.length - 1
            ]?.endingBalance || 0
        ).formatWithCurrency(currentCurrency, 2),
        style: [
          'tableFontSize',
          'tableSubHeader',
          'tableCellLeftAlign',
          'tableCellMarginLeftTopBottom'
        ]
      }
    ]);

    const now = moment.utc().tz(currentTimeZone).format('X');
    const date = dateTimeService.getFormattedDate(now);
    const orgLogo = currentOrganization?.organization?.logo
      ? currentOrganization.organization.logo.replace(
          /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
          currentOrganization.id
        )
      : INSTANCE.url + INSTANCE.logo;
    quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
      const docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        content: [
          {
            table: {
              widths: [240, '*'],
              headerRows: 1,
              body: [
                [
                  {
                    width: 180,
                    height: 30,
                    image: res.data,
                    margin: [5, 3, 0, 3],
                    style: 'tableHeader'
                  },
                  {
                    fillColor: '#eeeeee',
                    text: `Prepared by: ${currentAccount.getName()}\nPrepared on: ${date}`,
                    style: 'prepared'
                  }
                ]
              ]
            },
            layout: 'noBorders'
          },
          {
            text: '',
            margin: [0, 10, 0, 0]
          },
          helperPdfService.createHeader({
            title: 'BORROWERS'
          }),
          {
            text: clientNames,
            style: ['marginTop']
          },
          {
            text: '',
            margin: [0, 10, 0, 0]
          },
          helperPdfService.createHeader({
            title: 'STRUCTURE'
          }),
          {
            table: {
              headerRows: 1,
              widths: ['*', '*', '*', '*', '*', '*', '*'],
              body: structureBody
            },
            style: ['marginTop'],
            layout: 'defaultLayout'
          },
          {
            text: '',
            margin: [0, 10, 0, 0]
          },
          helperPdfService.createHeader({
            title: 'AMORTISATION SCHEDULE'
          }),
          {
            table: {
              dontBreakRows: true,
              headerRows: 1,
              widths: [20, '*', '*', '*', '*', '*', '*', '*'],
              body: amortizationSchedulesBody
            },
            style: ['marginTop'],
            layout: 'defaultLayout'
          },
          {
            text: '',
            margin: [0, 10, 0, 0]
          },
          helperPdfService.createHeader({
            title: 'DISCLAIMER'
          }),
          {
            text: 'This Amortisation schedule is provided to assist you with managing your financial records, closing balances shown in the Schedule are not an estimation of an early termination figure.',
            style: ['marginTop']
          }
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            margin: [0, 0, 0, 0]
          },
          subHeader: {
            fontSize: 12,
            bold: true,
            margin: [0, 10, 0, 4]
          },
          prepared: {
            fontSize: 10,
            alignment: 'right',
            margin: [0, 6, 5, 0]
          },
          marginTop: {
            margin: [0, 5, 0, 0]
          },
          tableFontSize: {
            fontSize: 10
          },
          tableHeader: {
            fillColor: '#eee'
          },
          tableSubHeader: {
            fillColor: '#f5f5f5'
          },
          tableMarginTop: {
            margin: [0, 10, 0, 0]
          },
          tableCellMarginTop: {
            margin: [0, 2, 0, 0]
          },
          tableCellMarginLeftTopBottom: {
            margin: [4, 2, 0, 2]
          },
          tableCellMarginRightTopBottom: {
            margin: [0, 2, 4, 2]
          },
          tableCellMarginTopBottom: {
            margin: [0, 2, 0, 2]
          },
          tableCellLeftAlign: {
            alignment: 'left'
          },
          tableCellRightAlign: {
            alignment: 'right'
          },
          tableCellCenterAlign: {
            alignment: 'center'
          }
        }
      };
      pdfMake.tableLayouts = {
        defaultLayout: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 1 : 0.5;
          },
          vLineWidth() {
            return 0.5;
          },
          hLineColor(i, node) {
            return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
          },
          vLineColor(i, node) {
            return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        },
        header: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 0 : 2;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor(i, node) {
            return i === node.table.body.length ? '#000' : '#fff';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        }
      };

      const fileName = `${moment.utc().year()}${moment.utc().month() + 1}${moment
        .utc()
        .date()}${isQuickTool ? ' Quick quote -' : ''} Amortisation schedule.pdf`;
      if (isQuickTool && !_.isEmpty(docDefinition)) {
        if (!_.isEmpty(docDefinition)) {
          if (isView) {
            pdfMake.createPdf(docDefinition).open();
          } else {
            pdfMake.createPdf(docDefinition).download(fileName);
          }
          deferred.resolve();
        }
      } else if (!isQuickTool && !_.isEmpty(docDefinition)) {
        if (isView) {
          helperPdfService.viewOrSavePdf({ docDefinition, isView: true }).then(() => {
            deferred.resolve();
          });
        } else {
          helperPdfService
            .viewOrSavePdf({
              ticket,
              docDefinition,
              fileName,
              isView: false
            })
            .then(() => {
              deferred.resolve();
            });
        }
      }
    });
    return deferred.promise;
  }
});
